export default {
      id: "settings-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "sprite.svg#settings-usage",
      toString: function () {
        return this.url;
      }
    }